"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriggerText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TriggerTextMixin = require("../../mixins/components/TriggerTextMixin");
/**
 * Inline trigger style used for `Tooltip` and `Popover` components in a body of text.
 *
 * `TriggerText` is normally used as a child of a `Popper` or `TooltipPopper`.
 *
 * @related ['Popover', 'Tooltip', 'Trigger', 'TriggerButton']
 * @since 7.0.0
 */
var TriggerText = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "TriggerText",
  componentId: "c11n-8-107-0__sc-d96jze-0"
})(["", ""], _TriggerTextMixin.TriggerTextMixin);
exports.TriggerText = TriggerText;
TriggerText.displayName = 'TriggerText';
TriggerText.defaultProps = {
  // Prevents submits when included in a form tag
  type: 'button'
};

/** @component */